export const USER_ROLES = {
    PM: 'ROLE_TMS_PM',
    TRANSLATOR: 'ROLE_TMS_TRANSLATOR'
};

export const USER_ROLE_OPTIONS = {
    [USER_ROLES.PM]: 'PM',
    [USER_ROLES.TRANSLATOR]: 'Translator'
};
